import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const putBuyerForecastHistoryNotificationsReadSlice = createApi('PutBuyerForecastHistoryNotificationsReadSlice', 'PUT');

const PutBuyerForecastHistoryNotificationsReadSlice = createSlice({
  name: 'PutBuyerForecastHistoryNotificationsReadSlice',
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(putBuyerForecastHistoryNotificationsReadSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(putBuyerForecastHistoryNotificationsReadSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(putBuyerForecastHistoryNotificationsReadSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default PutBuyerForecastHistoryNotificationsReadSlice.reducer;
